import { render, staticRenderFns } from "./CostObj.vue?vue&type=template&id=7dfd812a&scoped=true&"
import script from "./CostObj.vue?vue&type=script&lang=js&"
export * from "./CostObj.vue?vue&type=script&lang=js&"
import style0 from "./CostObj.vue?vue&type=style&index=0&id=7dfd812a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd812a",
  null
  
)

export default component.exports